export default __webpack_public_path__ + "static/media/25110803.f21557aa.png";